import WireframeLayout, { buildSidebarSections } from '@/components/WireframeLayout'

function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[520px] gap-0">
      {/* Illustration */}
      <div style={{ position: "relative", marginBottom: 32 }}>
        <div style={{
          width: 120, height: 120, borderRadius: 32,
          background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
          border: "2px dashed #cbd5e1",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 48, position: "relative",
        }}>
          <span role="img" aria-label="warehouse">🏭</span>
          <div style={{
            position: "absolute", bottom: -8, right: -8,
            width: 36, height: 36, borderRadius: 10,
            background: "#fff", border: "2px solid #e2e8f0",
            display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18,
          }}>
            <span role="img" aria-label="package">📦</span>
          </div>
        </div>
        {/* Floating dashes */}
        {[[-52, 10], [56, -18], [-40, 68]].map(([x, y], i) => (
          <div key={i} style={{
            position: "absolute", left: `calc(50% + ${x}px)`, top: `calc(50% + ${y}px)`,
            width: 28, height: 6, borderRadius: 3, background: "#e2e8f0",
          }} />
        ))}
      </div>

      <h2 style={{ fontSize: 18, fontWeight: 700, color: "#0f172a", letterSpacing: "-0.02em", marginBottom: 6 }}>
        No inventory data yet
      </h2>
      <p style={{ fontSize: 13, color: "#94a3b8", maxWidth: 380, textAlign: "center", lineHeight: 1.6, marginBottom: 32 }}>
        Connect your warehouses and SKU catalog to start tracking stock levels, days of supply, and cost of goods across all your fulfillment channels.
      </p>

      {/* Action cards */}
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", justifyContent: "center", maxWidth: 600 }}>
        <button
          style={{
            flex: "1 1 240px", maxWidth: 260,
            background: "#fff", border: "1.5px solid #e2e8f0", borderRadius: 16,
            padding: "20px 24px", cursor: "pointer",
            textAlign: "left", transition: "all 0.15s",
            boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
            fontFamily: "inherit",
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = "#3b82f6"; e.currentTarget.style.boxShadow = "0 0 0 3px rgba(59,130,246,0.08), 0 1px 4px rgba(0,0,0,0.04)"; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.04)"; }}
        >
          <div style={{
            width: 40, height: 40, borderRadius: 10,
            background: "linear-gradient(135deg, #eff6ff, #dbeafe)",
            border: "1px solid #bfdbfe",
            display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, marginBottom: 12,
          }}>🔗</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a", marginBottom: 4 }}>Setup data syncing</div>
          <div style={{ fontSize: 12, color: "#64748b", lineHeight: 1.55 }}>
            Connect your WMS, ERP, or channel platforms for real-time inventory sync.
          </div>
          <div style={{ marginTop: 12, fontSize: 11, color: "#3b82f6", fontWeight: 600, display: "flex", alignItems: "center", gap: 4 }}>
            Connect integrations →
          </div>
        </button>

        <button
          style={{
            flex: "1 1 240px", maxWidth: 260,
            background: "#fff", border: "1.5px solid #e2e8f0", borderRadius: 16,
            padding: "20px 24px", cursor: "pointer",
            textAlign: "left", transition: "all 0.15s",
            boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
            fontFamily: "inherit",
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = "#10b981"; e.currentTarget.style.boxShadow = "0 0 0 3px rgba(16,185,129,0.08), 0 1px 4px rgba(0,0,0,0.04)"; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.04)"; }}
        >
          <div style={{
            width: 40, height: 40, borderRadius: 10,
            background: "linear-gradient(135deg, #f0fdf4, #dcfce7)",
            border: "1px solid #bbf7d0",
            display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, marginBottom: 12,
          }}>📤</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a", marginBottom: 4 }}>Manual data upload</div>
          <div style={{ fontSize: 12, color: "#64748b", lineHeight: 1.55 }}>
            Import inventory via CSV template — warehouses, SKUs, and opening stock.
          </div>
          <div style={{ marginTop: 12, fontSize: 11, color: "#10b981", fontWeight: 600, display: "flex", alignItems: "center", gap: 4 }}>
            Download template →
          </div>
        </button>
      </div>

      {/* Hint row */}
      <div style={{
        marginTop: 36, display: "flex", alignItems: "center", gap: 20,
        padding: "12px 20px", background: "#f8fafc", borderRadius: 10, border: "1px solid #f1f5f9",
      }}>
        {[
          ["🏭 Warehouses", "Define locations & channels"],
          ["📦 SKU Catalog", "Map products & variants"],
          ["📊 Stock Levels", "Opening balances & costs"],
        ].map(([title, sub], i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {i > 0 && <div style={{ width: 1, height: 28, background: "#e2e8f0", marginRight: 12 }} />}
            <div>
              <div style={{ fontSize: 12, fontWeight: 600, color: "#64748b" }}>{title}</div>
              <div style={{ fontSize: 11, color: "#94a3b8" }}>{sub}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default function Empty() {
  return (
    <WireframeLayout
      title="Inventory"
      subtitle="Warehouses, SKU catalog & cost of goods"
      titleIcon="📦"
      sidebarLinks={buildSidebarSections(null, "inventory-empty")}
    >
      <EmptyState />
    </WireframeLayout>
  )
}
